module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAJFBMVEUAAAClpaWZmZmampqZmZmZmZmampqbm5ubm5ubm5uampqZmZmRYxxAAAAAC3RSTlMACMOw7OEwIWFwSRzuWm0AAAAtSURBVBjTY0AHHAJInNmKSJzSTUhS7NH0k0rZjOCweRvSXIKhG0mCgQsogQkAynQRlX6vU2kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_arrow_right.png
// module id = Olyi
// module chunks = 16